import { loadFabricDependencies } from '../fabric-dependencies'
import { IPageContext, ISettingStore } from '../models'

import { setPageContext, setRethrowExceptions } from './state'
import { initTelemetry } from './telemetry'

export const initialize = async (
  hostPageContext: IPageContext,
  rethrowErrors = false,
  _settingStore?: ISettingStore
) => {
  setPageContext(hostPageContext || {})
  setRethrowExceptions(rethrowErrors)

  initTelemetry(hostPageContext)

  if (hostPageContext.preloadFabricPackage) {
    await loadFabricDependencies()
  }
}
